import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import './notifications.style.scss';

/**
 * Class representing notifications component.
 * @extends Component
 * */
@inject('commonStore')
@observer
class Notifications extends Component {

  static propTypes = {
    commonStore: PropTypes.shape({
      hide: PropTypes.func,
      notifications: PropTypes.arrayOf(PropTypes.shape({})),
    }),
  };

  static defaultProps = {
    commonStore: {
      hide: () => {},
      notifications: []
    },
  };


  /**
   * Hides the current notification.
   * @param {object} notification - The current notification.
   * */
  hideNotification = notification => () => {
    const { commonStore: { hide } } = this.props;

    hide(notification);
  };

  render() {
    const { commonStore: { notifications } } = this.props;

    return (

      <div className="notifications">
        {notifications.map(notification => (
          <div key={notification.id} className={`notification text-center ${notification.type} alert alert-${notification.type}`}>
            <span>{notification.message}</span>
            <button type="button" className="close alert-close" onClick={this.hideNotification(notification)}>
              <span><FontAwesomeIcon icon={faTimes} /></span>
            </button>
          </div>
        ))}
      
      </div>
    );
  }

}

export default Notifications;



// WEBPACK FOOTER //
// ./src/common/components/notifications/notifications.component.js